import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import CustomButton from "components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { SURVEY_STATUS } from "store/reducers/surveyReducer";
import AddSurveyQuestion from "./AddSurveyQuestion";
import SurveyQuestionsList from "./SurveyQuestionsList";
import CloseSurveyModal from "./CloseSurveyModal";
import { useToasts } from "react-toast-notifications";

export default ({
  survey,
  onClose,
  activeSurvey,
  addQuestions,
  dispatch,
  teamQuestions,
  prePopulatedQuestions,
  selectedQuestions,
  isSubmittingAns,
  reload,
}) => {
  const { addToast } = useToasts();
  const [closeSurvey, setCloseSurvey] = useState(false);

  const handleAddQuestion = () => {
    dispatch({
      type: "handleAddQuestions",
      value: !addQuestions,
    });
  };

  if (!survey) return null;

  // Check if survey is assigned to the current user
  const isAssignedSurvey = survey.is_shared === true || (survey.original_survey !== null && survey.original_survey !== undefined);

  return (
    <Modal
      center
      open
      closeOnEsc={true}
      closeOnOverlayClick={true}
      classNames={{
        modalContainer: "modalContainer",
        modal: "manageSurveyModal",
      }}
      showCloseIcon={false}
      onClose={onClose}
    >
      <div className="modal fade popup-modal withcross manage-survey-popup">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="text-center createTaskHeading">
            <strong>Manage Survey: {survey.title}</strong>
          </h5>
          <CustomButton type="button" buttonClass="btnClose">
            <CloseIcon style={{ width: "20px" }} onClick={onClose} />
          </CustomButton>
        </div>

        <div className="manage-survey-content" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="d-flex justify-content-between gap-3 surveyQuesDiv mb-3">
            <div>
              <CustomButton
                buttonClass="addQuestBtn grad_btn"
                onClick={handleAddQuestion}
                disabled={survey.status === SURVEY_STATUS.INACTIVE || isAssignedSurvey}
                title={isAssignedSurvey ? "You cannot add questions to an assigned survey" : ""}
              >
                <FontAwesomeIcon icon={faPlus} /> &nbsp;Add Question
              </CustomButton>
            </div>
            <div>
              <CustomButton
                buttonClass="closeQuestBtn grad_btn"
                onClick={() => setCloseSurvey(true)}
                disabled={survey.status === SURVEY_STATUS.INACTIVE || isAssignedSurvey}
                title={isAssignedSurvey ? "You cannot close an assigned survey" : ""}
              >
                <FontAwesomeIcon icon={faWindowClose} /> &nbsp;Close Survey
              </CustomButton>
            </div>
          </div>

          <SurveyQuestionsList
            status={survey.status}
            surveyId={survey.id}
            teamId={survey.team_id}
            dispatch={dispatch}
            reload={reload}
            items={survey.questions || []}
            totalUser={survey.total_users}
            answeredUser={survey.answered_users}
          />

          {addQuestions && (
            <AddSurveyQuestion
              onClose={handleAddQuestion}
              dispatch={dispatch}
              teamQuestions={teamQuestions}
              prePopulatedQuestions={prePopulatedQuestions}
              selectedQuestions={selectedQuestions}
              isSubmittingAns={isSubmittingAns}
              activeSurvey={activeSurvey}
              reload={reload}
              addedCustomQuestionsCount={
                (survey.questions || []).filter((v) => v.custom_question === 1).length
              }
            />
          )}

          {closeSurvey && (
            <CloseSurveyModal
              onClose={(flag = false) => {
                if (flag) {
                  dispatch({
                    type: "setReload",
                    value: !reload,
                  });
                  addToast("Survey closed successfully.", {
                    appearance: "success",
                  });
                  onClose();
                }
                setCloseSurvey(false);
              }}
              surveyId={survey.id}
              teamId={survey.team_id}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};